import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapDirectSelect, Utils } from "mapbox-gl-draw-snap-mode";

import { getFeatureTarget } from "./helper";

const { modes, constants: Constants } = MapboxDraw;

const directSelect: DrawCustomMode = {
  ...SnapDirectSelect,

  onSetup: function (opts) {
    const state = SnapDirectSelect.onSetup?.call(this, opts);

    // We don't use the snapping guides added during setup so we remove them to avoid having to delete them later
    this.deleteFeature(Utils.IDS.HORIZONTAL_GUIDE, { silent: true });
    this.deleteFeature(Utils.IDS.VERTICAL_GUIDE, { silent: true });

    return state;
  },

  onMouseDown: function (state, event) {
    // @ts-expect-error featureTarget is possibly undefined & needs to allow for that
    event.featureTarget = getFeatureTarget.call(this, event, this._ctx.options);
    modes.direct_select.onMouseDown?.call(this, state, event);
  },

  onClick: function (state, event) {
    // @ts-expect-error featureTarget is possibly undefined & needs to allow for that
    event.featureTarget = getFeatureTarget.call(this, event, this._ctx.options);
    modes.direct_select.onClick?.call(this, state, event);
  },

  /**
   * By default direct select will not delete the selected feature, only selected vertices.
   * Here we override that behavior so that if no vertices are selected the entire feature
   * is deleted.
   */
  onTrash: function (state) {
    if (state.selectedCoordPaths?.length > 0) {
      // Vertices are selected, so fallback to default behavior
      SnapDirectSelect.onTrash?.call(this, state);
    } else if (state.featureId) {
      // No vertices selected, so delete the entire feature
      this.deleteFeature(state.featureId);
      this.changeMode(Constants.modes.SIMPLE_SELECT, {});
    }
  },
};

export default directSelect;
